import { createContext, useState } from "react";

export interface StoryContextProps {
  updateNavigation: (
    index: number,
    isDarkNav?: boolean,
    scroll?: boolean,
    item?: unknown
  ) => void;
  setLineHeights: (heights: number[]) => void;
  activeIndex: number;
  darkNav: boolean;
  lineHeights: number[];
}

export const StoryContext = createContext<StoryContextProps>({
  updateNavigation: (
    _index: number,
    _isDarkNav?: boolean,
    _scroll?: boolean,
    _item?: unknown
  ) => {},
  setLineHeights: () => {},
  activeIndex: 0,
  darkNav: true,
  lineHeights: [],
});

export const StoriesProvider = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [darkNav, setDarkNav] = useState(false);
  const [lineHeights, setLineHeights] = useState<number[]>([]);

  const updateNavigation = (
    index: number,
    isDarkNav: boolean = true,
    scroll: boolean = false,
    item: HTMLElement = null
  ) => {
    setActiveIndex(index);
    setDarkNav(isDarkNav);

    if (scroll && item) {
      // @ts-expect-error type mistmatch
      const nextSection = item?.parentNode?.nextElementSibling;

      window.scroll({
        top: nextSection.getBoundingClientRect().top + window.scrollY,
        behavior: "smooth",
      });
    }
  };

  return (
    <StoryContext.Provider
      value={{
        // @ts-expect-error type mismatch
        updateNavigation,
        setLineHeights,
        activeIndex,
        darkNav,
        lineHeights,
      }}
    >
      {children}
    </StoryContext.Provider>
  );
};
